import { RefObject, useLayoutEffect, useRef, useState } from 'react';

export const useElementHeight = <T extends HTMLElement>(): [RefObject<T | null>, number] => {
  const ref = useRef<T>(null);
  const [height, setHeight] = useState(0);

  useLayoutEffect(() => {
    const element = ref.current;
    if (!element) return undefined;

    const measure = () => setHeight(element.getBoundingClientRect().height);
    measure();

    const observer = new ResizeObserver(measure);
    observer.observe(element);

    return () => observer.disconnect();
  }, []);

  return [ref, height];
};
